import React from 'react'
import { ErrorWrapper, Input, Label, Rules, TabChanger } from '../../../styles/newStyles/Register.styled'
import Text from '../../../core/utils/Text'

const SigninPage = ({
    onInputValueChange,
    inputValues,
    validationStatus,
}) => {



    return (
        <>
            <div className='flex flex-col gap-2'>
                <Label htmlFor='email-phone'>
                    <Text tid={'enter-phone-email'} />
                </Label>
                <Input
                    type='text'
                    placeholder='شماره موبایل یا ایمیل'
                    onChange={(e) => onInputValueChange(e, 'main')}
                    value={inputValues.mobileOrEmail}
                    autoFocus={true}
                    status={validationStatus}
                    id='email-phone'
                />
                {validationStatus === 'error' && (
                    <ErrorWrapper>
                        <Text tid='format-wrong' className='text-sm' />
                    </ErrorWrapper>
                )}
            </div>
            <TabChanger className={'gap-2'}>
                <Text tid={'not-have-account'} />
                <Rules
                    onClick={() => {
                        window.location.assign('/user/auth/signup')
                    }}
                    fontSize='1rem'
                >
                    <Text
                        className='text-main hover:opacity-80'
                        tid={'signup'}
                    />
                </Rules>
            </TabChanger>
        </>
    )
}

export default SigninPage